import React, { Component } from 'react';
import {  Row, Col } from 'reactstrap';
import { Link } from 'react-router';
import { TextInputField,DateInputField, GetInputField } from '../../Elements';
import moment from 'moment';
import { imgStoragePath, displayDateFormat } from '../../../../constants';


export default class ReferenceLinkList extends Component {
  constructor(props) {
    super(props);
  }


  updateForm = () => {

  }
  render() {
  const { shopVisit, error, index, detailErr } = this.props;
  let type = 'edit';
  return(
    <tr className="shopvisit-acctacment-row">
	 <td> 
      <div>
        <TextInputField
            value={shopVisit.link}
            type={'edit'}
            keyParam="link"
            error={''}
            updateForm={(value)=>this.props.updateForm({type: 'link', value:value, sectionType: 'reference_links', index:this.props.index})}
        />
        </div>
      </td>
      <td >
      <div>
        <TextInputField
              value={shopVisit.description}
              type={'edit'}
              keyParam="description"
              error={''}
              updateForm={(value)=>this.props.updateForm({type: 'description', value:value, sectionType: 'reference_links', index:this.props.index})}
        />
        </div>
      </td>
      <td>
      { shopVisit.created_at? moment(shopVisit.created_at).format(displayDateFormat) : '--'}
      </td>
			<td>
         <div>
          <img className="profile-pic" src={shopVisit.user.profile_pic} alt="img"/>
          <span>{shopVisit.user.name}</span>
				</div>
      </td>
			<td className="download-block">
        <Link  target="_blank" to = {shopVisit.link}>
            <i className="fas fa-external-link-alt" style={{ 'color' : '#aaa', 'font-size' : '14px', 'position' : 'relative', 'top' : '0.5px' }}></i>
        </Link>
		  	<img width="12" onClick = {() => this.props.toggleDelModal(shopVisit.id, 'reference_links', index)} className="" src={imgStoragePath+"delete_red.png"}/>
      </td>
      </tr>
    )
  }
}
